type Nullable<T> = T | null;

export default function undefinedIfNull<T>(value: Nullable<T>): T | undefined {
  return value ?? undefined;
}
